import { render, staticRenderFns } from "./NameReservationExtensions.vue?vue&type=template&id=fb08d216&scoped=true&"
import script from "./NameReservationExtensions.vue?vue&type=script&lang=js&"
export * from "./NameReservationExtensions.vue?vue&type=script&lang=js&"
import style0 from "./NameReservationExtensions.vue?vue&type=style&index=0&id=fb08d216&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb08d216",
  null
  
)

export default component.exports